module.exports = __webpack_public_path__ + "static/media/tree-step-5_2.568f49f3.svg";